"use strict";
var appn;
(function (appn) {
    var posthog;
    (function (posthog) {
        function capture(eventName, properties) {
            try {
                captureInternal(eventName, properties);
            }
            catch (_a) {
            }
        }
        posthog.capture = capture;
        function captureInternal(eventName, properties) {
            if (!window.posthog || !appn.requestProvider.isTrialing || !appn.requestUser.allowUsageAnalytics)
                return;
            if (window.location.href.toLowerCase().indexOf('backoffice') > -1)
                return;
            const props = properties || {};
            props.ts = props.ts || new Date().toISOString();
            props.providerId = appn.requestProvider.id;
            props.userId = appn.requestUser.id;
            props.isFirstSession = appn.requestUser.isFirstSession;
            window.posthog.capture(eventName, props);
        }
        function init() {
            $('.main-sidebar .nav-link').on('click', function () {
                const $this = $(this);
                const label = $this.find('p').text().trim();
                const href = $this.attr('href');
                if (!href || href === '#')
                    return;
                appn.posthog.capture('menu_click', {
                    label: label,
                    href: href ? href.split('?')[0] : href
                });
            });
            const startTime = new Date().getTime();
            $(window).on('beforeunload', function () {
                const endTime = new Date().getTime();
                const durationMs = endTime - startTime;
                appn.posthog.capture('page_view_duration', {
                    durationMs: durationMs,
                    path: window.location.pathname
                });
            });
        }
        posthog.init = init;
    })(posthog = appn.posthog || (appn.posthog = {}));
})(appn || (appn = {}));
